import { useState } from 'react';

import { FormControlLabel, Switch, Typography } from '@mui/material';

import { themeColors } from 'colors';
import { VoiceContentStateTypes } from 'pages/ContentVoiceBuilderPage/types';
import { setTimeoutMessage } from 'pages/ContentVoiceBuilderPage/voiceCallActions';

const defaultTimeoutMessage = "Sorry, we didn't receive any input. Please try again.";

type Props = {
    dispatchVoiceContentAction: React.Dispatch<any>;
    isContentLoading: boolean;
    voiceContentState: VoiceContentStateTypes;
};

const TimeoutMessageToggle = ({ dispatchVoiceContentAction, isContentLoading, voiceContentState: state }: Props) => {
    const [isPlayTimeoutMessageEnabled, setIsPlayTimeoutMessageEnabled] = useState(
        !!state.voiceJson?.fallback?.timeoutMessage?.length
    );

    return (
        <>
            <FormControlLabel
                control={
                    <Switch
                        color="secondary"
                        checked={isPlayTimeoutMessageEnabled}
                        onChange={(e) => {
                            setIsPlayTimeoutMessageEnabled(!isPlayTimeoutMessageEnabled);
                            if (e.target.checked) {
                                dispatchVoiceContentAction(setTimeoutMessage(defaultTimeoutMessage));
                            } else {
                                dispatchVoiceContentAction(setTimeoutMessage(''));
                            }
                        }}
                        size="small"
                    />
                }
                disabled={isContentLoading}
                label={
                    <Typography color={themeColors.text.primary} variant="body2">
                        Play timeout message
                    </Typography>
                }
            />
            <Typography color={themeColors.text.disabled} ml="30px" variant="body2">
                "{defaultTimeoutMessage}"
            </Typography>
        </>
    );
};

export default TimeoutMessageToggle;
